"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const objectIdTypes_1 = __importDefault(require("./objectIdTypes"));
function getPageById(id) {
    const [type, giata] = id.split('-');
    const objectType = objectIdTypes_1.default[type];
    if (!objectType)
        return null;
    return {
        name: objectType.name,
        page: objectType.page,
        objectId: giata,
        objectType: type,
    };
}
exports.default = getPageById;
//# sourceMappingURL=getPageById.js.map